import comp from "./ChildrenPage";
export default comp;
